/* eslint-disable react-hooks/exhaustive-deps */
import {
  Add,
  DownloadOutlined,
  FileUploadOutlined,
  FilterAltOutlined,
  TimelineOutlined,
} from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Badge, Box, Button, Grid } from "@mui/material";
import SearchBox from "components/ui/searchBox";
import useApi from "hooks/useApi";
import { useDebounce } from "hooks/useDebounce";
import useDidMountEffect from "hooks/useDidMountEffect";
import useQueries from "hooks/useQueries";
import { useEffect, useState } from "react";
import { AiOutlineProject } from "react-icons/ai";

const Header = ({
  activeMenu,
  setActiveMenu,
  setOpenFilter,
  setSearch,
  setPagination,
  pagination,
  permissions,
  search,
  filters,
  setFilters,
  setOpenImportProject,
  reloadCount,
  setReloadCount,
}) => {
  const { setQueries } = useQueries();
  const { loading, fetchData } = useApi();
  const [searchText, setSearchText] = useState();
  const debouncedText = useDebounce(searchText, 1000);

  useDidMountEffect(() => {
    setSearch(debouncedText);
    setPagination({ ...pagination, current_page: 1 });
  }, [debouncedText]);

  const handleExport = async () => {
    const res = await fetchData(
      {
        method: "post",
        url: "/api/admin/project-customer/export",
        data: {
          type: "xlsx",
          trash_export: false,
          search,
          ...filters,
        },
      },
      false
    );
    if (res.success) window.open(res?.data?.file);
  };

  const { loading: countLoading, fetchData: fetchUnsolvedProjectsCount } =
    useApi();
  const [unsolvedProjectsCount, setUnsolvedProjectsCount] = useState();

  useEffect(() => {
    let endpoint = {
      method: "post",
      url: `/api/admin/project-customer/status-track/count`,
      data: filters,
    };
    const getActivityList = async () => {
      const result = await fetchUnsolvedProjectsCount(endpoint, false);
      if (result.success) setUnsolvedProjectsCount(result?.data);
    };
    getActivityList();
  }, [filters, reloadCount]);

  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      p="15px 20px"
      gap="10px"
    >
      <Grid item>
        {!!(permissions["list(own)"] || permissions["list(global)"]) && (
          <SearchBox
            handleSearch={(text) => setSearchText(text)}
            placeholder={"Search in table.."}
          />
        )}
      </Grid>
      <Box sx={{ display: "flex", gap: "10px" }}>
        <Badge
          overlap="circular"
          badgeContent={unsolvedProjectsCount}
          showZero
          max={99}
          color="red"
          sx={{
            color: "#fff",
            fontWeight: "500",
            "& .MuiBadge-badge": {
              right: 5,
              top: 3,
            },
          }}
        >
          <Button
            variant={filters?.unsolved_projects === 1 ? "solid" : "outlined"}
            startIcon={<AiOutlineProject />}
            onClick={() => {
              setFilters({
                ...filters,
                unsolved_projects: filters?.unsolved_projects ? 0 : 1,
              });
              setReloadCount((pre) => pre + 1);
            }}
          >
            Unsolved Projects
          </Button>
        </Badge>

        <Button
          variant={activeMenu === "summary" ? "solid" : "outlined"}
          startIcon={<TimelineOutlined />}
          onClick={() =>
            setActiveMenu(activeMenu === "summary" ? "" : "summary")
          }
          disabled={!permissions.summery}
        >
          Summary
        </Button>
        <Button
          variant={"outlined"}
          startIcon={<FilterAltOutlined />}
          onClick={() => setOpenFilter(true)}
          disabled={!(permissions["list(own)"] || permissions["list(global)"])}
        >
          Advanced Filters
        </Button>
        <LoadingButton
          loading={loading}
          loadingPosition="start"
          variant="outlined"
          startIcon={<DownloadOutlined />}
          onClick={handleExport}
          disabled={!permissions.export}
        >
          Export
        </LoadingButton>
        <Button
          variant="outlined"
          startIcon={<FileUploadOutlined />}
          onClick={() => setOpenImportProject(true)}
          disabled={!permissions.import}
        >
          Import
        </Button>
        <Button
          variant="outlined"
          startIcon={<Add />}
          onClick={() => setQueries("m=0")}
          disabled={!permissions.create}
        >
          Add Customer To Project
        </Button>
      </Box>
    </Grid>
  );
};

export default Header;
